import React from 'react'
import styled from '@emotion/styled'

interface FloatingMapButtonProps {
	onClick: () => void
}

const MapIcon = () => (
	<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
		<path d="M14.106 5.553a2 2 0 0 0 1.788 0l3.659-1.83A1 1 0 0 1 21 4.619v12.764a1 1 0 0 1-.553.894l-4.553 2.277a2 2 0 0 1-1.788 0l-4.212-2.106a2 2 0 0 0-1.788 0l-3.659 1.83A1 1 0 0 1 3 19.381V6.618a1 1 0 0 1 .553-.894l4.553-2.277a2 2 0 0 1 1.788 0z" />
		<path d="M15 5.764v15" /><path d="M9 3.236v15" />
	</svg>
)

export const FloatingMapButton = ({ onClick }: FloatingMapButtonProps) => (
	<Button type="button" onClick={onClick} aria-label="Ver mapa">
		<MapIcon />
		Mapa
	</Button>
)

const Button = styled.button`
	display: none;

	@media (max-width: 767px) {
		display: flex;
	}

	position: fixed;
	left: 50%;
	bottom: calc(20px + env(safe-area-inset-bottom));
	transform: translateX(-50%);
	z-index: 300;
	align-items: center;
	gap: 8px;
	background: #3200C1;
	color: #fff;
	border: none;
	border-radius: 24px;
	padding: 12px 22px;
	font-family: nunito, sans-serif;
	font-size: 14px;
	font-weight: 700;
	box-shadow: 0 4px 16px rgba(50, 0, 193, 0.35);
	cursor: pointer;

	&:active {
		background: #2900a3;
	}
`
